module.exports = __webpack_public_path__ + "static/media/btn_prev.d14b54eb.svg";